import { render, staticRenderFns } from "./responsibility.vue?vue&type=template&id=782d940c"
import script from "./responsibility.vue?vue&type=script&lang=js"
export * from "./responsibility.vue?vue&type=script&lang=js"
import style0 from "./responsibility.vue?vue&type=style&index=0&id=782d940c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports